// src/app/shared/guards/dashboard.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs/operators';
// Update the path below to the correct relative path where auth.service.ts actually exists
// Update the path below to the correct relative path where auth.service.ts actually exists
import { AuthService } from '../auth.service';

// dashboard.guard.ts
export const dashboardGuard: CanActivateFn = (route, state) => {
  const authService = inject<AuthService>(AuthService);
  const router = inject(Router);

  // Check if this is a payment callback on the payment page
  if (state.url.includes('/payment') && state.url.includes('id=')) {
    console.log('Payment callback detected in guard, allowing access');
    return true; // Allow immediate access for payment callback
  }

  return authService.isInitialized$.pipe(
    filter((initialized) => initialized),
    take(1),
    switchMap(() => authService.isAuthenticated$),
    take(1),
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        console.log('Not authenticated, redirecting to login with returnUrl');
        authService.login();
        return false;
      }
      console.log('Authenticated, allowing access to:', state.url);
      return true;
    })
  );
};
